import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import actionCreator from "../../../redux/action/actionCreator";

// core-components

import Toast from "../../../components/MessageToast";
import CreateForm from "../../components/forms/PartnerForm";
import { CREATE_PARTNER, UPDATE_PARTNER } from "../../../redux/partners/types";
import Loading from "../../../components/isLoading";
import { toast } from "react-toastify";
import BreadCrumps from "../../../components/BreadCrups";
import { fetchPartnerData } from "../../../redux/partners";
import { useNavigate } from "react-router";

export default (props) => {
  const { partnerId } = props;
  const dispatch = useDispatch();

  const operationStore = useSelector((store) =>
    partnerId ? store.updatePartnerGlobalStore : store.createPartnerGlobalStore
  );

  const partnerData = useSelector((state) => state.partnerGlobalStore);
  const [state, setState] = useState({ openToast: false });

  const openToast = ({ message, type, onClose }) =>
    Toast({ message, type, duration: 3000, onClose });

  useEffect(() => {
    if (partnerId) {
      dispatch(fetchPartnerData(partnerId));
    }
  }, []);

  const handleFormSubmit = async (formData) => {
    const { name, pictureUrl, weblink } = formData;
    if ((!name, !pictureUrl, !weblink) && !partnerId) {
      return openToast({
        message: "Please Enter All required fields",
        type: "warning",
      });
    }
    const partnerInfo = { name, pictureUrl, weblink };
    await toast.promise(
      dispatch(
        actionCreator({
          method: partnerId ? "PATCH" : "POST",
          path: partnerId ? `/api/partners/${partnerId}` : "/api/partners",
          actionType: partnerId ? UPDATE_PARTNER : CREATE_PARTNER,
          data: partnerInfo,
        })
      ),
      {
         pending: `${!partnerId ? "Creating" : "Updating"} partner`,
      }
    );
    setState({ ...state, openToast: true });
  };
  const navigate = useNavigate();
  if (operationStore.message && state.openToast) {
    Toast({
      message: operationStore.message,
      type: operationStore.message.includes("successful") ? "success" : "error",
      onClose: () =>
        operationStore.message.includes("successful") ? navigate(-1) : null,
    });

    setState({ ...state, openToast: false });
  }

  const crumps = [
    {
      title: "Partners",
      path: "/partners",
    },
  ];

  return (
    <div>
      <BreadCrumps crumps={crumps} />
      {partnerId && partnerData.loading ? (
        <Loading />
      ) : (
        <div>
          <CreateForm
            isCreate={partnerId ? false : true}
            title="Create a Partner"
            onSubmit={handleFormSubmit}
            openToast={openToast}
            baseContentData={partnerId ? partnerData.data : {}}
            isLoading={operationStore.loading}
          />
        </div>
      )}
    </div>
  );
};
